import React from "react";
import { Route } from "react-router-dom";

import Home from '../../pages/public/Home';
import SignIn from '../../pages/public/SignIn';
import SignUp from '../../pages/public/SignUp';
import SignOut from '../../pages/public/SignOut';
import ForgotPassword from '../../pages/public/ForgotPassword';
import PasswordReset from '../../pages/public/PasswordReset';
import AcceptInvite from '../../pages/public/AcceptInvite'
import TermsOfService from '../../pages/public/TermsOfService';
import PrivacyPolicy from '../../pages/public/PrivacyPolicy';
import Support from '../../pages/public/Support';
import RefundPolicy from '../../pages/public/RefundPolicy';
import ShippingPolicy from '../../pages/public/ShippingPolicy';


const publicRoutes = (
  <React.Fragment>
    <Route path="/" element={<Home />} />
    <Route path="/sign-up" element={<SignUp />} />
    <Route path="/sign-in" element={<SignIn />} />
    <Route path="/sign-out" element={<SignOut />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/password-reset/:uid/:token" element={<PasswordReset />} />
    <Route path="/accept-invite/:profile_id/:invite_token/:invite_type" element={<AcceptInvite />} />
    
    {/* Important: Below policy and support page links are submitted in Google-Auth/Whatsapp/Razorpay dashboards */}
    <Route path="/support" element={<Support />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/refund-policy" element={<RefundPolicy />} />
    <Route path="/shipping-policy" element={<ShippingPolicy />} />
  </React.Fragment>
);
export default publicRoutes;
